import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { logout } from '../../store/loginSlice'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'

import {
  avatar11,
  avatar13,
  avatar17,
  avatar2,
  avatar29,
  logo,
  logoSmall,
} from '../../utils/images/imagepath'

const Header = () => {
  const [scrolled, setScrolled] = useState(false)
  const dispatch = useDispatch()
  const authuser = useSelector((state: any) => state?.login?.userDetails)
  const profileDetails = useSelector(
    (state: any) => state?.common?.profileDetails,
  )
  const layoutsettings = useSelector((state: any) => state?.layoutsettings)

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0
      setScrolled(isScrolled)
    }

    window.addEventListener('scroll', handleScroll)

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    const faviconLink = document.getElementById('favicon') as HTMLLinkElement
    if (faviconLink) {
      faviconLink.href = layoutsettings.favicon
    } else {
      console.error('Favicon link element not found')
    }
  }, [layoutsettings])

  return (
    <>
      headers
      <style>
        {`
      :root {
        --primary-color: ${layoutsettings?.primary_color};
        --secondary-color: ${layoutsettings?.secondary_color};
      }
    `}
      </style>
      <div className='header'>
        {/* <!-- Logo --> */}
        <div className='header-left active'>
          <a href='index.html' className='logo logo-normal'>
            <img src={logo} alt='' />
          </a>
          <a href='index.html' className='logo-small'>
            <p>M</p>
          </a>
          <a id='toggle_btn' href='javascript:void(0);'>
            <FontAwesomeIcon icon={faChevronLeft} />
          </a>
        </div>
        {/* <!-- /Logo --> */}

        <a id='mobile_btn' className='mobile_btn' href='#sidebar'>
          <span className='bar-icon'>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </a>

        {/* <!-- Header Menu --> */}
        <ul className='nav user-menu'>
          {/* <!-- Search --> */}
          <li className='nav-item nav-searchinputs'>
            <div className='top-nav-search'>
              <form action='#'>
                <div className='search-input'>
                  <input
                    type='text'
                    className='form-control'
                    placeholder='Search Something...'
                  />
                  <div className='search-icon'>
                    <button type='submit'>
                      <i className='icon-search'></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </li>
          {/* <!-- /Search --> */}

          <li className='nav-item'>
            <a href='javascript:void(0);' className='btn btn-light'>
              <i className='feather-phone-call'></i> Call with Driver
            </a>
          </li>

          <li className='nav-item'>
            <a href='javascript:void(0);' className='btn btn-primary'>
              <i className='feather-message-circle'></i> Chat with Driver
            </a>
          </li>

          <li className='nav-item nav-item-box'>
            <a href='javascript:void(0);'>
              <i className='icon-settings'></i>
            </a>
          </li>

          {/* <!-- Notifications --> */}
          <li className='nav-item nav-item-box dropdown noti-dropdown'>
            <a
              href='javascript:void(0);'
              className='dropdown-toggle nav-link'
              data-bs-toggle='dropdown'
            >
              <i className='icon-notificaiton'></i>{' '}
              <span className='badge badge-pill'></span>
            </a>
            <div className='dropdown-menu dropdown-menu-end notifications'>
              <div className='topnav-dropdown-header'>
                <span className='notification-title'>Notifications</span>
                <a href='javascript:void(0)' className='clear-noti'>
                  {' '}
                  Clear All{' '}
                </a>
              </div>
              <div className='noti-content'>
                <ul className='notification-list'>
                  <li className='notification-message'>
                    <a href='javascript:void(0);'>
                      <div className='media d-flex'>
                        <span className='avatar avatar-sm flex-shrink-0'>
                          <img
                            className='avatar-img rounded-circle'
                            alt='User Image'
                            src='assets/img/profiles/avatar-02.jpg'
                          />
                        </span>
                        <div className='media-body flex-grow-1'>
                          <p className='noti-details'>
                            <span className='noti-title'>Carlson Tech</span> has
                            approved{' '}
                            <span className='noti-title'>your estimate</span>
                          </p>
                          <p className='noti-time'>
                            <span className='notification-time'>
                              4 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className='notification-message'>
                    <a href='javascript:void(0);'>
                      <div className='media d-flex'>
                        <span className='avatar avatar-sm flex-shrink-0'>
                          <img
                            className='avatar-img rounded-circle'
                            alt='User Image'
                            src='assets/img/profiles/avatar-11.jpg'
                          />
                        </span>
                        <div className='media-body flex-grow-1'>
                          <p className='noti-details'>
                            <span className='noti-title'>
                              International Software Inc
                            </span>{' '}
                            has sent you a invoice in the amount of{' '}
                            <span className='noti-title'>$218</span>
                          </p>
                          <p className='noti-time'>
                            <span className='notification-time'>
                              6 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className='notification-message'>
                    <a href='javascript:void(0);'>
                      <div className='media d-flex'>
                        <span className='avatar avatar-sm flex-shrink-0'>
                          <img
                            className='avatar-img rounded-circle'
                            alt='User Image'
                            src='assets/img/profiles/avatar-17.jpg'
                          />
                        </span>
                        <div className='media-body flex-grow-1'>
                          <p className='noti-details'>
                            <span className='noti-title'>John Hendry</span> sent
                            a cancellation request{' '}
                            <span className='noti-title'>Apple iPhone XR</span>
                          </p>
                          <p className='noti-time'>
                            <span className='notification-time'>
                              8 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li className='notification-message'>
                    <a href='javascript:void(0);'>
                      <div className='media d-flex'>
                        <span className='avatar avatar-sm flex-shrink-0'>
                          <img
                            className='avatar-img rounded-circle'
                            alt='User Image'
                            src='assets/img/profiles/avatar-13.jpg'
                          />
                        </span>
                        <div className='media-body flex-grow-1'>
                          <p className='noti-details'>
                            <span className='noti-title'>
                              Mercury Software Inc
                            </span>{' '}
                            added a new product{' '}
                            <span className='noti-title'>
                              Apple MacBook Pro
                            </span>
                          </p>
                          <p className='noti-time'>
                            <span className='notification-time'>
                              12 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
              <div className='topnav-dropdown-footer'>
                <a href='javascript:void(0);'>View all Notifications</a>
              </div>
            </div>
          </li>
          {/* <!-- /Notifications --> */}

          <li className='nav-item dropdown has-arrow main-drop'>
            <a
              href='javascript:void(0);'
              className='dropdown-toggle nav-link userset'
              data-bs-toggle='dropdown'
            >
              <span className='user-info'>
                <span className='user-letter'>
                  <img src={avatar29} className='img-fluid' alt='Profile' />
                </span>
              </span>
            </a>
            <div className='dropdown-menu dropdown-menu-end'>
              <a href='index.html' className='dropdown-item'>
                <i className='ti ti-layout-2'></i> Dashboard
              </a>
              <a href='javascript:void(0);' className='dropdown-item'>
                <i className='ti ti-user-pin'></i> My Profile
              </a>
              <Link
                className='dropdown-item'
                onClick={() => dispatch(logout())}
                to='/#'
              >
                <i className='ti ti-lock' /> Logout
              </Link>
            </div>
          </li>
        </ul>
      </div>
    </>
  )
}

export default Header
